/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from "react";
import * as Ui from "./styles";
import {
  EyeWatermarkIcon,
  HiddenEyeWatermarkIcon,
} from "../../../../../../components/Icons";
import { useDispatch, useSelector } from "react-redux";
import { fetchEvolutiveCrossedQuestions } from "src/stores/actions/evolutiveCross";
import useFlashMessage from "src/hooks/FlashMessage";
import { EVOLUTIVE_CROSSING_NETWORK_ERROR } from "src/sections/GroupCards/EvolutiveCrossChartCard/config/util/Constantes";
import { getParsedQuestionData } from "../../util";

export default function CrossQuestionCollapsibleList({
  // Titulo da pesquisa
  surveyTitle,
  // Titulo da questão principal selecionada no dashboard
  questionTitle,
  // Id da pesquisa
  surveyId,
  // Id da questão
  questionId,
  // Id do Cliente
  customerId
}) {

  const dispatch = useDispatch();
  const {
    payload: { data }, error
  } = useSelector(
    (state) => state.evolutiveCross.configuration.step_one.crossedQuestions
  );

  //hooks
  const [ handleFlashMessage ] = useFlashMessage();

  useEffect(() => {
    if(error) {
      const { title, message } = EVOLUTIVE_CROSSING_NETWORK_ERROR;

      handleFlashMessage(
        title,
        message,
        'error'
      );
    }
  }, [error])

  useEffect(() => {
    const data = getParsedQuestionData([{ surveyId, questionId }])
    if (questionId && customerId) {
      fetchEvolutiveCrossedQuestions(
        customerId,
        data,
        dispatch
      );
    }
  }, [customerId, surveyId, questionId, dispatch]);

  const [isCollapsed, setIsCollapsed] = useState(false);
  const [questionCrossed] = data || [];
  function toggle() {
    setIsCollapsed(!isCollapsed);
  }

  return (
    <Ui.Container>
      <Ui.Row>
        <Ui.SurveyCard>
          <h2>Avaliação Atual</h2>
          <label>{surveyTitle}</label>
        </Ui.SurveyCard>
        <Ui.SurveyCard>
          <h2>Pergunta Principal</h2>
          <label>{questionTitle}</label>
        </Ui.SurveyCard>
      </Ui.Row>
      <Ui.ButtonShowQuestions
        onClick={() => toggle()}
        isCollapsed={isCollapsed}
      >
        {isCollapsed ? (
          <>
            <HiddenEyeWatermarkIcon />
            Recolher as perguntas do cruzamento
          </>
        ) : (
          <>
            <EyeWatermarkIcon />
            Ver todas as perguntas do cruzamento
          </>
        )}
      </Ui.ButtonShowQuestions>
      {isCollapsed && (
        <Ui.ListCrossingQuestion questionCrossed={questionCrossed?.perguntas_cruzadas}>
          {questionCrossed?.perguntas_cruzadas.map(({ id, enunciado }, index) => (
              <Ui.ItemCrossingQuestion key={id}>
                <label>{index +2}</label>
                <span />
                <label>{enunciado}</label>
              </Ui.ItemCrossingQuestion>
            ))}
        </Ui.ListCrossingQuestion>
      )}
    </Ui.Container>
  );
}
